import React from 'react';

type KeepBrowsingLinkProps = {
  title: string;
  linkTo: string;
  className?: string;
};

function KeepBrowsingLink(props: KeepBrowsingLinkProps) {
  const { title, linkTo, className } = props;

  return (
    <a
      href={linkTo}
      className={`KeepBrowsingLink ${className && className}`}
      rel="noopener noreferrer"
    >
      {title}
    </a>
  );
}

export default KeepBrowsingLink;
